import { ADMIN_DETAIL, NET__CONNECT, CSRF_TOKEN, JWT_TOKEN, REFRESH_TOKEN, COMMON_CONTENT } from "../types";

const INITIAL_STATE = {
    activeNet: true,
    csrfToken: null,
    jwtToken: null,
    adminDetail: null,
    refreshToken: null,
    commonData: null, // Temporary Data
};

export default (state = INITIAL_STATE, action) => {
    const { type, payload } = action;
    switch (type) {
        case NET__CONNECT:
            return {
                ...state,
                activeNet: payload,
            };
        case CSRF_TOKEN:
            return {
                ...state,
                csrfToken: payload,
            };
        case JWT_TOKEN:
            return {
                ...state,
                jwtToken: payload,
            };
        case COMMON_CONTENT:
            return {
                ...state,
                commonData: payload,
            };
        case REFRESH_TOKEN:
            return {
                ...state,
                refreshToken: payload,
            };
        case ADMIN_DETAIL:
            if (payload) {
                return {
                    ...state,
                    adminDetail: payload,
                };
            } else {
                return state;
            }
        default:
            return state;
    }
};
